import React from "react";
import PhoneNumber from "./PhoneNumber";

type Props = {
  image?: string;
  name: string;
  phone: string;
  email: string;
  roles: string[];
};

const Person = ({ image, name, phone, email, roles }: Props) => {
  return (
    <div>
      {image && (
        <div>
          <img src={image} alt={name} style={{ width: "200px" }} />
        </div>
      )}
      <div>
        <strong>{name}</strong>
      </div>
      <div>
        {roles.map((r, i) => (
          <>
            {i !== 0 && <br />}
            {r}
          </>
        ))}
      </div>
      <div>
        <PhoneNumber number={phone} />
      </div>
      <div>
        <a href={"mailto:" + email}>{email}</a>
      </div>
    </div>
  );
};

export default Person;
